import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_30207947: FaireBrandEntity = {
  token: "b_30207947",
  type: "brand",
  name: "HealthyCell",
  avatarUrl:
    "https://cdn.faire.com/fastly/291d165cd910f6de2854838196f03bad82b2e0c655d916c5ac8b11d2bfd435f9.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/3cef19aac87a74b6ccd8842b982e80e1d58c56eecfd9c5dd815b7d377005afa1.png",
  logoUrl:
    "https://cdn.faire.com/fastly/291d165cd910f6de2854838196f03bad82b2e0c655d916c5ac8b11d2bfd435f9.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/3cef19aac87a74b6ccd8842b982e80e1d58c56eecfd9c5dd815b7d377005afa1.png",
  location: "Mount Pleasant, SC, USA",
  minimumOrderDollars: 100,
  rating: 5,
  reviewCount: 1,
  isInsider: true,
  description:
    "Nutrients you can absorb. Results you can measure. An experience you'll love.\n\nHealthycell is a growing brand of dietary supplements on the cutting edge of innovation, giving it the potential to change the way 240 million Americans take nutritional supplements every day. They use a patent-pending MICROGEL™ technology that is replacing tablets, capsules, and powders. 40% of Americans have difficulty swallowing pills. Now they can supplement with a pill-free, great-tasting, convenient experience that gives them maximum absorption of all the nutrients they need without the vitamin taste.",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:44:09.430Z",
    importedBy: "entity-db-cli",
  },
};
